import chooseForm from './ProductFormIndex';

export { default as LabeledInput } from './formControls/LabeledInput';
export default chooseForm;
